(function () {
    var bookTabs = {
        activeTab: null,

        init: function (url) {
            if (url !== undefined && url[0] === 't' && $('#' + url[1]).length) {
                $('[href=#' + url[1] + ']').click();
            }

            bookTabs.control();
            bookTabs.removeExtraTabs();
        },
        control: function () {
            $('.book-tabs .tab__nav').on('click', 'a', function () {
                var currentLocation =
                    window.location.href.indexOf('#') !== -1 ? window.location.href.split('#')[0] : window.location;
                window.location = currentLocation + $(this).attr('href').replace('#', '#t=');
            });
            $('.book-tabs .access-for-ebook').click(function () {
                $('#toccon').click();
            });

            /**
             * This will make any link attribute contain '#desired tab name such as "reviews"' will open the tab
             */
            $("a[href*='#t=']").on('click', function (e) {
                var targetTab = e.target.href.split('#t=')[1];
                $(`#${targetTab}con`).click();
            });
        },
        removeExtraTabs: function () {
            let conText;
            if ($('.book-tabs').length) {
                if (
                    $('#pane-Chapter .table-of-content, #toc .table-of-content').html() === '' ||
                    $('#pane-Chapter').html() === ''
                ) {
                    // needs clean as this instance might not be needed
                    conText = 'con';
                    $('#pane-Chapter' + conText).hide();
                    $('#toc' + conText).hide();
                    const current = $('#toccon').parent();
                    if (current.is(':first-child')) {
                        current.next('li');
                        const next = current.next('li').addClass('active');
                        $(next.find('a').attr('href')).addClass('active');
                    }
                }
                if ($('#pane-Supplementary').html() === '') {
                    // needs clean as this instance might not be needed
                    conText = 'con';
                    $('#pane-Supplementary' + conText).hide();
                }
                if (
                    ($('#toc.tab__pane >*').length === 1 && $('#toc.tab__pane .access-content').length === 1) ||
                    $('#toc.tab__pane >*').length === 0
                ) {
                    conText = 'con';
                    $('#toc' + conText).hide();
                }
                if (
                    ($.trim($('#suppl >*').length) === '1' && $('#suppl .access-content').length === 1) ||
                    $.trim($('#suppl >*').length) === '0'
                ) {
                    conText = 'con';
                    $('#suppl' + conText).hide();
                }

                if ($('#toc' + conText).is(':hidden')) {
                    $('.access-content .access-for-ebook').addClass('disabled');
                }
            }
        },
    };

    UX.bookTabs = bookTabs; // add to global namespace
})();
